import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AltaProveedorService {

  constructor(private http: HttpClient) { }
  //registroProveedor/sendForm corresponde a alta proveedor. Esta invertido en apifrontend
  sendForm(altaProveedor: FormData): Observable<any> {
    return this.http.post(`${environment.urlApi}altaProveedor/sendForm`, altaProveedor);
  }
}
